/*
 * @Descripttion:
 * @version:
 * @Author: ZhaoWei
 * @QQ: 1512763623
 * @Date: 2020-11-12 15:26:11
 * @LastEditors: ABC
 * @LastEditTime: 2021-07-03 19:05:27
 */
const Decimal = require('decimal.js');

export const initPrototye = (Vue, router) => {
  Vue.prototype.$Decimal = Decimal

  Vue.prototype.$eventHub = Vue.prototype.$eventHub || new Vue()

  Vue.prototype.$toFixed = (n, k, z) => {
    if (isNaN(n)) {
      return 0
    }
    if (!k) k = 4
    let a = 10 ** k
    if (Number(n) < 0) {
      a = Math.ceil(Number(n) * a) / a
    } else {
      a = Math.floor(Number(n) * a) / a
    }
    if (z) {
      return a
    } else {
      return a.toFixed(k)
    }
  }

  Vue.prototype.$numberScale = (e, scale, max, min) => {
    let value = (typeof e === 'object') ? e.target.value : e + ''
    let scales = {
      s1: /^(\-)*(\d+)\.(\d).*$/,
      s2: /^(\-)*(\d+)\.(\d\d).*$/,
      s3: /^(\-)*(\d+)\.(\d\d\d).*$/,
      s4: /^(\-)*(\d+)\.(\d\d\d\d).*$/,
      s5: /^(\-)*(\d+)\.(\d\d\d\d\d).*$/,
      s6: /^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/,
    }
    value = value.replace(/[^\d.]/g, "");
    value = value.replace(/^\./g, "");
    value = value.replace(/\.{2,}/g, ".");
    value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
    if (scale) {
      value = value.replace(scales['s' + scale], '$1$2.$3');
    } else if(value){
      value = parseInt(value)
    }
    if ((max || max == 0) && value > max) value = max
    // if (value && min && value < min) value = min
    if (typeof e === 'object') {
      e.target.value = value;
    }
    return value
  }
}
